import * as React from 'react';
import { FormGroup, Label } from 'reactstrap';

export const TextArea = ({ label, name, input, type, placeholder, id, meta: { touched, error } })   => {

  return (
    <FormGroup>
      {label !== '' && <Label htmlFor={id}>{label}</Label>}
     <textarea id={id} className={`form-control ${touched && error && 'is-invalid'}`} placeholder={placeholder || ''} rows={4} {...input} />
      {touched && error && 
       <span className="error">{error}</span>}
    </FormGroup>
  );
};

export default TextArea;